import Administracao from "./Administracao";
import GestorServicos from "./GestorServicos";
import Pesquisas from "./Pesquisas";

export default {
  Administracao,
  GestorServicos,
  Pesquisas,
};
